import { ExpenseDetailsForm_PL } from './privateLease';

export const ExpenseDetailsForm = {
  /**
   * PrivateLease
   */
  PL: ExpenseDetailsForm_PL,
};
